module.exports = __webpack_public_path__ + "static/media/withdraw.e5cd68b0.svg";